<template>
  <div
    class="flex justify-center items-center h-30 p-2 lg:p-5 border border-[rgba(0, 0, 0, 0.1)] rounded-md transition-all duration-300 hover:translate-y-[-6px] hover:cursor-pointer hover:shadow-[0px_0px_12px_rgba(0,0,0,0.12)]"
    @click="gotoPath(path)"
  >
    <div class="w-full block box-border">
      <div class="flex flex-row">
        <div class="w-12 grid text-3xl place-items-center">
          <SvgIcon v-if="meta?.svgIcon" :name="meta?.svgIcon" />
        </div>
        <div class="flex flex-col">
          <div class="flex flex-col lg:flex-row items-center gap-0 lg:gap-2">
            <span class="text-sm py-1 px-1.5">{{ meta?.title }}</span>
            <span
              class="bg-[#E8F6FB] rounded-sm text-xs py-0.5 px-2.5 text-primary dark:opacity-75"
              :class="[meta?.tag == 'dev' ? 'bg-[#FFF2CC] text-[#FF8C00]!' : '']"
              >{{ meta?.tag }}</span
            >
          </div>
          <div class="text-xs opacity-50 pt-1.5 pl-1.5">{{ meta?.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { RouteMeta } from '~/types/router';

interface Props {
  path: string;
  meta?: RouteMeta;
}

defineProps<Props>();

const router = useRouter();
const gotoPath = (path: string) => {
  navigateTo(path);
};
</script>
